var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Accordion from "../Accordion";
import ArtGeneratorService from "../../services/ArtGeneratorService";
;
function TitleStep(_a) {
    var titleId = _a.titleId, onChange = _a.onChange, onNext = _a.onNext, isOpen = _a.isOpen, onToggle = _a.onToggle, isValid = _a.isValid;
    var _b = useState(), titles = _b[0], setTitles = _b[1];
    var _c = useState(titleId), selectedTitle = _c[0], setSelectedTitle = _c[1];
    useEffect(function () {
        var active = true;
        ArtGeneratorService.getTitles()
            .then(function (data) {
            if (active)
                setTitles(data);
        })
            .catch(function () {
        });
        return function () { active = false; };
    }, []);
    function handleTitleChange(e) {
        var value = e.target.value;
        setSelectedTitle(value);
        onChange(value);
    }
    ;
    var isValidTitle = titleId !== "";
    return (_jsxs(Accordion, __assign({ title: "T\u00EDtulo", name: "titleId", step: 2, isOpen: isOpen, onToggle: onToggle, isValid: isValid }, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "label-default", htmlFor: "title-select" }, { children: "Chamada:" })), _jsxs("select", __assign({ id: "title-select", className: "select-art-generator-default", value: selectedTitle, onChange: handleTitleChange }, { children: [_jsx("option", __assign({ value: "" }, { children: "Selecione uma op\u00E7\u00E3o" })), titles === null || titles === void 0 ? void 0 : titles.map(function (title) { return (_jsx("option", __assign({ value: title.id }, { children: title.label }), title.id)); })] }))] })), _jsx("div", __assign({ className: "step-footer" }, { children: _jsx("button", __assign({ type: "button", className: "continue-button button-with-blue-border", onClick: onNext, disabled: !isValidTitle }, { children: "Continuar" })) }))] })));
}
export default TitleStep;
